import React from 'react'
import { Card, styled } from '@mui/material'

const RoundedCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  //boxShadow: '0 8px 8px 0 rgb(0 0 0 / 20%)',
  width: '100%',
  height: '100%',
  padding: '1rem',
  mt: 1,
  mb: 3,
  //display: 'flex',
  //flexDirection: 'column',
  //justifyContent: 'space-between',
  //alignItems: 'center',
  //textAlign: 'center',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0 16px 32px 0 rgb(0 0 0 / 20%)',
  },
}))

export const StyledCard = ({ children }: any) => {

  return <RoundedCard>
    {children}
  </RoundedCard>
}

//<Card variant='outlined' sx={{ marginBottom: 3, mt: 1, height: '100%' }}>